import './App.css';
import { useState,useEffect } from 'react';
import {Routes,Route,Router} from 'react-router-dom';
import Home from './Pages/Home/Home.jsx';
import Navber from './Pages/Home/Navber.jsx';
import PropertiesHome from './Pages/Properties/PropertiesHome.jsx';
import Projects from './Pages/Projects/Projects.jsx';
import Footer from './Pages/Home/Footer.jsx';
import PropertyDetails from './Pages/Properties/PropertiesDetails.jsx';
import ContactUs from './Contact.jsx';
import Aboutus from './About.jsx'
import PropertyDetails1 from "./Pages/Property Details/DetailsMain.jsx"
import GalleryPage from './ExtraComponent/GalleryPage.jsx';
import Login from './Pages/Authentication/Login.jsx';
import { RegisterUser } from './Services/Operations/ProductAPI.js';
import Registration from './Pages/Authentication/Registration.jsx';
import Profile from './Pages/Authentication/Profile.jsx';


function App() {
  return (
    <div className="App">
      <Navber/>
      <Routes>
        <Route path='/' element={<Home/>}/>
         <Route path='/login' element={<Login/>}/>
          <Route path='/register' element={<Registration/>}/>
           <Route path='/profile' element={<Profile/>}/>
        <Route path='/projects' element={<Projects/>}/>
        <Route path='/properties' element={<PropertiesHome/>}/>
        <Route path='/properties/details' element={<PropertyDetails1/>}/>
        <Route path='/contact' element={<ContactUs/>}/>
        <Route path='/about' element={<Aboutus/>}/>
        <Route path='/gallery' element={<GalleryPage/>}/>
        
        
        
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
